<template>
  <div>
    <mdb-navbar color="indigo" class="container-fluid">
      <mdb-navbar-brand class="white-text">
        Trolley seal tags [BETA]
      </mdb-navbar-brand>
    </mdb-navbar>
    <mdb-alert color="danger" v-if="error" class="m-2">{{error}}</mdb-alert>
    <mdb-container>
      <mdb-row v-if="isloading" class="pt-4">
        <mdb-col class="text-center">
          <mdb-spinner big multicolor />
        </mdb-col>
      </mdb-row>
      <div v-else>
        <mdb-row class="pt-2">
          <mdb-col>
            <h4>Aircrafts currently sealed</h4>
          </mdb-col>
        </mdb-row>
        <mdb-row v-if="lockedplanes.length">
          <mdb-col>
            <mdb-tbl sm>
              <mdb-tbl-head>
                <tr>
                  <th>Aircraft</th>
                  <th>Seal installed at</th>
                </tr>
              </mdb-tbl-head>
              <mdb-tbl-body>
                <tr v-for="(aircraft,index) in lockedplanes" v-bind:key="index" v-on:click="openValidationScreen(aircraft)">
                  <td>
                    <span class="font-weight-bold">{{aircraft.aircraftunit.call_sign}}</span><br />
                    <em>{{aircraft.locationtype}}</em>
                  </td>
                  <td>
                    {{formatDate(aircraft.created_at)}}<br />
                    By: {{aircraft.created_by_user.name}}
                  </td>
                </tr>
              </mdb-tbl-body>
            </mdb-tbl>
          </mdb-col>
        </mdb-row>
        <mdb-row v-else>
          <mdb-col>
            <mdb-alert color="info">No aircraft sealed</mdb-alert>
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <hr />
            <mdb-btn class="container-fluid" color="pink" v-on:click="displaychooseplanemodal">Seal a new aircraft</mdb-btn>
          </mdb-col>
        </mdb-row>
      </div>
    </mdb-container>
    <mdb-modal :show="openchooseaircraftmodal" @close="openchooseaircraftmodal=false;" info size="fluid">
      <mdb-modal-header class="text-center">
        <mdb-modal-title tag="h4" bold class="w-100">Choose an aircraft</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="mx-3">
        <mdb-tbl>
          <mdb-tbl-body>
            <tr v-for="(aircraft,index) in availableplanes" v-bind:key="index" v-on:click="chooseAircraftToLock(aircraft)">
              <td>
                <span class="font-weight-bold">{{aircraft.callsign}} ({{aircraft.locationtype}})</span>
                <br />
                <em>{{aircraft.position}}</em>
              </td>
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>
      </mdb-modal-body>
    </mdb-modal>
    <mdb-modal :show="scannermodalopen" @close="scannermodalopen=false;" info size="fluid">
      <mdb-modal-header class="text-center">
        <mdb-modal-title tag="h4" bold class="w-100">Scanner for {{aircraftchoosen.callsign}}</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="mx-3">
        <mdb-alert color="danger" v-if="scanerror">{{scanerror}}</mdb-alert>
        <ImageBarcodeReader @decode="onScannerDecode" @error="onScannerError" class="pt-4"></ImageBarcodeReader>
        <mdb-tbl sm>
          <mdb-tbl-body>
            <tr v-for="(code,index) in this.barcodesscanned" v-bind:key="index">
              <td>{{code}}</td>
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>
        <hr />
        <mdb-btn v-if="barcodesscanned.length" size="lg" class="container-fluid" outline="elegant" v-on:click="lockthisplane">Lock this plane</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>
    <mdb-modal :show="showvalidationscreen" @close="showvalidationscreen=false;" info size="fluid">
      <mdb-modal-header class="text-center" v-if="aircrafttagstovalidate">
        <mdb-modal-title tag="h4" bold class="w-100">Validation for {{aircrafttagstovalidate.aircraftunit.call_sign}} ({{aircrafttagstovalidate.locationtype}})</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="p-0">
        <mdb-alert color="danger" v-if="scanerror">{{scanerror}}</mdb-alert>
        <ImageBarcodeReader @decode="onScannerValidationDecode" @error="onScannerError" class="pt-4"></ImageBarcodeReader>
        <mdb-tbl>
          <mdb-tbl-head>
            <tr>
              <th>To be scanned</th>
              <th>Scanned</th>
              <th>Errors</th>
            </tr>
          </mdb-tbl-head>
          <mdb-tbl-body>
            <tr>
              <td>
                <div v-for="(code,index) in codestovalidate" v-bind:key="index">{{code}}</div>
              </td>
              <td>
                <div v-for="(code,index) in barcodesvalidationscanned" v-bind:key="index">{{code}}</div>
              </td>
              <td>
                <div v-for="(code,index) in barcodesvalidationscannederror" v-bind:key="index">{{code}}</div>
              </td>
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>
        <div class="p-5">
          <mdb-btn v-if="codestovalidate.length === 0" size="lg" class="container-fluid" outline="elegant" v-on:click="validationdone">Validation done</mdb-btn>
        </div>
      </mdb-modal-body>
    </mdb-modal>
  </div>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbNavbar,
  mdbNavbarBrand,
  mdbSpinner,
  mdbAlert,
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
} from 'mdbvue';
import { StreamBarcodeReader, ImageBarcodeReader } from 'vue-barcode-reader';
import Apicall from '@/libs/Apicall';

export default {
  name: 'trolleysealtags',
  data() {
    return {
      error: null,
      scanerror: null,
      isloading: true,
      lockedplanes: [],
      availableplanes: [],
      openchooseaircraftmodal: false,
      scannermodalopen: false,
      barcodesscanned: [],
      aircraftchoosen: {},
      codestovalidate: [],
      barcodesvalidationscanned: [],
      barcodesvalidationscannederror: [],
      aircrafttagstovalidate: null,
      showvalidationscreen: false,
    };
  },
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbNavbar,
    mdbNavbarBrand,
    mdbSpinner,
    mdbAlert,
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbTbl,
    mdbTblBody,
    // StreamBarcodeReader,
    ImageBarcodeReader,
    mdbTblHead,
  },
  mounted() {
    this.loadCurrentLockPlanes();
  },
  methods: {
    loadCurrentLockPlanes() {
      this.isloading = true;
      const self = this;
      const api = new Apicall();
      api.call('GET', 'api/trolley-seal-tag/locked-planes').then((response) => {
        self.isloading = false;
        if (response.status === 'OK') {
          self.error = null;
          self.lockedplanes = response.data;
        } else {
          self.error = response.msg;
        }
      });
    },
    displaychooseplanemodal() {
      const api = new Apicall();
      const self = this;
      api.call('GET', 'api/trolley-seal-tag/aircraft-avail-to-lock').then((response) => {
        if (response.status === 'OK') {
          self.openchooseaircraftmodal = true;
          self.availableplanes = response.data;
        } else {
          self.error = response.msg;
        }
      });
    },
    chooseAircraftToLock(aircraft) {
      this.barcodesscanned = [];
      this.aircraftchoosen = aircraft;
      this.openchooseaircraftmodal = false;
      this.scannermodalopen = true;
      this.scanerror = null;
    },
    onScannerDecode(val) {
      if (!this.barcodesscanned.includes(val)) {
        this.beep();
        this.barcodesscanned.push(val);
      }
    },
    onScannerValidationDecode(val) {
      this.beep();
      this.scanerror = null;
      if (!this.codestovalidate.includes(val) && !this.barcodesvalidationscanned.includes(val) && !this.barcodesvalidationscannederror.includes(val)) {
        this.barcodesvalidationscannederror.push(val);
      } else if (this.codestovalidate.includes(val)) {
          this.barcodesvalidationscanned.push(val);
          this.codestovalidate = this.codestovalidate.filter((e) => e !== val);
      }
    },
    onScannerError(val) {
      this.scanerror = val.message;
      window.setTimeout(() => { this.scanerror = null; }, 3000);
    },
    beep() {
      const snd = new Audio('data:audio/wav;base64,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');
      snd.play();
    },
    lockthisplane() {
      if (window.confirm('Are you sure you want to lock this aircraft?')) {
        const self = this;
        const api = new Apicall();
        api.call('POST', 'api/trolley-seal-tag/lock-aircraft', { codes: this.barcodesscanned, aircraft: this.aircraftchoosen }).then((response) => {
          self.scannermodalopen = false;
          self.loadCurrentLockPlanes();
        });
      }
    },
    formatDate(_thedate) {
      const thedate = new Date(_thedate);
      const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      };
      return thedate.toLocaleDateString(this.$store.state.currentlang === 'fr' ? 'fr-CA' : 'en-CA', options);
    },
    openValidationScreen(aircraft) {
      const self = this;
      const api = new Apicall();
      this.scanerror = null;
      this.aircrafttagstovalidate = aircraft;
      api.call('POST', 'api/trolley-seal-tag/get-tag-codes-for-aircraft', { sealid: aircraft.id }).then((response) => {
        self.codestovalidate = [];
        self.barcodesvalidationscannederror = [];
        self.barcodesvalidationscanned = [];
        if (response.status === 'OK') {
          self.codestovalidate = response.data;
          self.showvalidationscreen = true;
        } else {
          self.error = response.msg;
        }
      });
    },
    validationdone() {
      const api = new Apicall();
      const self = this;
      api.call('POST', 'api/trolley-seal-tag/validation-done', { aircraft: this.aircrafttagstovalidate, codes: this.barcodesvalidationscanned }).then((response) => {
        self.codestovalidate = [];
        self.barcodesvalidationscannederror = [];
        self.barcodesvalidationscanned = [];
        self.showvalidationscreen = false;
        self.loadCurrentLockPlanes();
      });
    },
  },
};
</script>
